import { createSelector } from '@reduxjs/toolkit';

const getDashboardInterface = state => state.dashboardInterface;

export const showSearchTooltipSelector = createSelector(
  getDashboardInterface,
  ({ showSearchTooltip }) => showSearchTooltip,
);
